import type { FC, ReactNode } from "react";
import { Fragment } from "react";
import Date, { DateProps } from "../atom/date";

type Props = DateProps & {
  label?: ReactNode;
  placeholder?: ReactNode;
};

export const CreatedDate: FC<Props> = (props) => {
  const { value, label = "Ngày tạo", placeholder } = props;

  if (!value) {
    return <Fragment>{placeholder}</Fragment>;
  }

  return (
    <Fragment>
      {label}: <Date value={value} />
    </Fragment>
  );
};
